<ng-template #openPanelCta>
    <button
        interacta-button
        type="button"
        [icon]="'ainteracta-logo-filled'"
        [label]="'AI.DISCOVERY.OPEN_AI_PANEL' | translate"
        [size]="'regular'"
        [style]="'tonal'"
        (click)="openAIPanel.emit()"
    ></button>
</ng-template>

<ng-template #dialogTemplate>
    <div
        aria-modal="true"
        cdkTrapFocus
        cdkTrapFocusAutoCapture
        class="flex max-h-[91.666667vh] w-fit max-w-[91.666667vw] flex-col overflow-hidden rounded-2xl bg-surface-C p-16 shadow [--video-max:calc(91.666667vh_-_184px)] [--video-size:max(320px,min(480px,var(--video-max)))] xl:[--video-size:max(320px,min(576px,var(--video-max)))] 2xl:[--video-size:max(320px,min(720px,var(--video-max)))]"
        role="dialog"
        [attr.aria-labelledby]="titleId"
    >
        <div
            class="mb-8 flex w-0 min-w-full shrink-0 items-center justify-between gap-x-16"
        >
            <div class="flex min-w-0 items-center gap-x-8">
                <interacta-image
                    [alt]="''"
                    [classes]="'size-32'"
                    [src]="logoSrc()"
                />
                <h2 class="typo-t6" [id]="titleId">
                    {{ 'AI.DISCOVERY.DIALOG_TITLE' | translate }}
                </h2>
            </div>
            <button
                interacta-icon-button
                type="button"
                [icon]="'close'"
                [label]="'UI.BUTTON.CLOSE' | translate"
                (click)="closing.emit()"
            ></button>
        </div>

        <div
            class="mt-6 flex min-h-0 w-full flex-col justify-between gap-24 lg:flex-row lg:px-8"
        >
            <div class="flex shrink-0 flex-col self-start">
                <video
                    class="aspect-square w-(--video-size) max-w-full rounded-8 object-cover [&:fullscreen]:object-contain"
                    controls
                    muted
                    playsinline
                    [attr.aria-label]="
                        'AI.ACCESSIBILITY.DISCOVERY_VIDEO' | translate
                    "
                    [attr.autoplay]="autoplay ? '' : null"
                    [poster]="videoPosterSrc()"
                    [src]="videoSrc()"
                ></video>

                <div
                    class="mt-24 flex shrink-0 justify-end lg:max-xl:[@media(min-height:655px)]:hidden xl:max-2xl:[@media(min-height:730px)]:hidden 2xl:[@media(min-height:770px)]:hidden"
                >
                    <ng-container [ngTemplateOutlet]="openPanelCta" />
                </div>
            </div>

            <div
                class="hidden h-(--video-size) shrink-0 flex-col lg:w-412 xl:w-480 2xl:w-520 lg:max-xl:[@media(min-height:655px)]:flex xl:max-2xl:[@media(min-height:730px)]:flex 2xl:[@media(min-height:770px)]:flex"
            >
                <div
                    class="flex min-h-0 flex-1 flex-col gap-y-24 overflow-y-auto"
                >
                    @for (feature of features; track feature.title) {
                        <div class="flex flex-col">
                            <h3 class="typo-t5">
                                {{ feature.title | translate }}
                            </h3>
                            <p class="typo-medium">
                                {{ feature.description | translate }}
                            </p>
                        </div>
                    }
                </div>

                <div class="mt-24 flex shrink-0 justify-end">
                    <ng-container [ngTemplateOutlet]="openPanelCta" />
                </div>
            </div>
        </div>
    </div>
</ng-template>
